document.addEventListener("turbo:load", function () {
  // Elementos del menú
  const menu = document.getElementById('slide-out');
  const hamburgerButton = document.getElementById('hamburger-menu');
  const closeButton = document.getElementById('close-menu');
  const menuContent = menu.querySelector('.fixed.inset-y-0.right-0');
  const menuOverlay = menu.querySelector('.fixed.inset-0.bg-black');

  // Funciones del menú
  function openMenu() {
    menu.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    
    // Pequeño delay para permitir que la clase hidden se quite antes de la transición
    setTimeout(() => {
      menuOverlay.classList.remove('opacity-0');
      menuContent.classList.remove('translate-x-full');
    }, 10);
  }

  function closeMenu() {
    menuOverlay.classList.add('opacity-0');
    menuContent.classList.add('translate-x-full');
    
    // Esperar a que termine la transición antes de ocultar
    setTimeout(() => {
      menu.classList.add('hidden');
      document.body.style.overflow = '';
    }, 300);
  }

  // Event Listeners
  hamburgerButton.addEventListener('click', function(event) {
    event.stopPropagation();
    openMenu();
  });

  closeButton.addEventListener('click', function(event) {
    event.stopPropagation();
    closeMenu();
  });

  menuOverlay.addEventListener('click', function(event) {
    event.stopPropagation();
    closeMenu();
  });

  // Cerrar el menú cuando la pantalla cambie a tamaño desktop (md)
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 768) { // 768px es el breakpoint md de Tailwind
      closeMenu();
    }
  });

  // Cerrar menú al hacer click en un enlace
  const menuLinks = menu.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });
});